"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobx_state_tree_1 = require("mobx-state-tree");

var ColorUtil_1 = __importDefault(require("../../utils/ColorUtil"));

var ColorTypes_1 = require("./ColorTypes");

var ColorPickerModelFactory = mobx_state_tree_1.types.model('ColorPickerModel', {
  paletteId: mobx_state_tree_1.types.optional(mobx_state_tree_1.types.string, ColorUtil_1.default.NoIdOrHexValue),
  paletteColors: mobx_state_tree_1.types.optional(mobx_state_tree_1.types.array(ColorTypes_1.FillModel), []),
  favoriteColors: mobx_state_tree_1.types.optional(mobx_state_tree_1.types.array(mobx_state_tree_1.types.string), []),
  ancestorLevel: mobx_state_tree_1.types.number
}).actions(function (self) {
  return {
    setPaletteColors: function setPaletteColors(colors) {
      var _a;

      if (colors === void 0) {
        colors = [];
      }

      self.paletteColors.length = 0;

      (_a = self.paletteColors).push.apply(_a, colors);
    },
    setFavoriteColors: function setFavoriteColors(colors) {
      var _a;

      if (colors === void 0) {
        colors = [];
      }

      self.favoriteColors.length = 0;

      (_a = self.favoriteColors).push.apply(_a, colors);
    }
  };
}).actions(function (self) {
  return {
    loadColors: function loadColors() {
      var grandParent = mobx_state_tree_1.getParent(self, self.ancestorLevel);
      return grandParent.loadColors(self.paletteId).then(function (_a) {
        var paletteColors = _a[0],
            favoriteColors = _a[1];
        self.setPaletteColors(paletteColors);
        self.setFavoriteColors(favoriteColors);
        return Promise.resolve(null);
      });
    }
  };
}).actions(function (self) {
  return {
    setPaletteId: function setPaletteId(paletteId) {
      if (paletteId !== self.paletteId) {
        self.paletteId = paletteId;
        self.loadColors();
      }
    }
  };
}).views(function (self) {
  return {
    getPaletteColors: function getPaletteColors(hasDefaultFillColor) {
      if (hasDefaultFillColor === void 0) {
        hasDefaultFillColor = false;
      }

      return hasDefaultFillColor ? __spreadArrays([ColorUtil_1.default.NoIdOrHexValue], self.paletteColors) : __spreadArrays(self.paletteColors);
    },
    getFavoriteColors: function getFavoriteColors() {
      return self.favoriteColors;
    },
    getSystemPaletteColors: function getSystemPaletteColors() {
      var grandParent = mobx_state_tree_1.getParent(self, self.ancestorLevel);
      var dashboardColorSet = grandParent.getDashboardColorSet();
      return dashboardColorSet.filter(function (color) {
        return color.hexValue !== 'transparent';
      }).map(function (color) {
        return color.hexValue;
      });
    }
  };
});
exports.default = ColorPickerModelFactory;
